module.exports = __webpack_public_path__ + "img/LDOGE-alt.338a6ef3.svg";